/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".gallery-container[_ngcontent-%COMP%]{min-height:400px;padding:10px;margin-bottom:40px}.top-info[_ngcontent-%COMP%]{padding:2%}[_nghost-%COMP%]     .remax-notification.mobile-only{position:relative}@media (min-width:600px){.gallery-wrapper[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);border-radius:2px}}"];
export { styles as styles };
